var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkButton',{staticClass:"register",attrs:{"to":_vm.yLoginPath,"type":"secondary","size":"sm","external":""}},[_c('p',[_vm._v("Yahoo! JAPAN IDで新規会員登録")])])}
var staticRenderFns = []

export { render, staticRenderFns }